<div class="subscription-container" id="holding-container" *ngIf="!stripeError">
  <div *ngIf="initialLoading" class="initial-loading">
    {{ 'common.loading' | translate }}
    <div class="cssload-container">
      <div class="cssload-speeding-wheel"></div>
    </div>
  </div>

  <div *ngIf="internalLoading" class="loading-cover">
    <div class="cssload-container">
      <div class="cssload-speeding-wheel"></div>
    </div>
  </div>

  <div class="container-subs-list" *ngIf="!initialLoading">
    <div class="container-heading">
      <label
        *ngIf="(isPreview && selectedPlanId) || (!isPreview && !isChangingPlan)"
        >{{ 'subscription.currentPlanDetails' | translate }}</label
      >
      <label
        *ngIf="(isPreview && selectedPlanId) || (!isPreview && !isChangingPlan)"
        >{{ 'subscription.paymentInfo' | translate }}</label
      >
      <label
        *ngIf="(!isPreview && isChangingPlan) || (isPreview && !selectedPlanId)"
        >{{ 'subscription.choosePlan' | translate }}</label
      >

      <label
        *ngIf="(isPreview && selectedPlanId) || (!isPreview && !isChangingPlan)"
      >
        {{ 'subscription.activeSubscriptions' | translate }}
      </label>

      <ops-annual-monthly-switch
        *ngIf="(!isPreview && isChangingPlan) || (isPreview && !selectedPlanId)"
        [value]="selectedInterval"
        (valueChange)="onIntervalChange($event)"
      ></ops-annual-monthly-switch>

      <ops-currency-switch
        *ngIf="noExistingSubscriptions"
        [value]="selectedCurrency"
        (valueChange)="onChangeCurrency($event)"
      ></ops-currency-switch>
    </div>

    <div
      class="flex flex-column mt-25 justify-center align-center m-auto"
      *ngIf="
        (!isPreview && isChangingPlan) ||
        isCreatingPlan ||
        (isPreview && !selectedPlanId)
      "
    >
      <div class="container-subscriptions">
        <ops-subscription-card
          *ngFor="let plan of subscriptionPlans"
          [plan]="plan"
          [showMonthly]="showingMonthly"
          (selectPlan)="onSelectPlan($event)"
          (changePlan)="onChangePlan()"
          (cancelSubscription)="onCancelSubscription($event)"
          [isDisabled]="isPreview"
          [selectedPlanId]="selectedPlanId"
          [selectedCurrency]="selectedCurrency"
          [isCreatingPlan]="isCreatingPlan"
          [isSelected]="plan.id === selectedPlanId"
        />
        <!--  -->
      </div>
      <button
        *ngIf="
          allSubscriptions?.length > 0 && (
          (isChangingPlan && selectedPlanId) ||
          isCreatingPlan ||
          (!isPreview && selectedPlanId))
        "
        (click)="onGoBackClick()"
        class="back-button"
      >
        {{ 'common.goBack' | translate }}
      </button>
    </div>

    <div
      class="container-details"
      *ngIf="(isPreview && selectedPlanId) || (!isPreview && !isChangingPlan)"
    >
      <ops-subscribed-card 
        *ngIf="selectedSubscriptionData?._id"
        [plan]="selectedPlanItem"
        (addOnUpdates)="addOnUpdates($event)"
        [subscriptionData]="selectedSubscriptionData"
        [subscriptionId]="selectedSubscriptionData?._id"
        [isPreview]="!isChangingPlan"
        [showMonthly]="showMonthly"
        [isDisabled]="isPreview"
        [selectedCurrency]="selectedCurrency"
        [addOns]="mappedAddOns"
        (changePlan)="onChangePlan()"
        (cancelSubscription)="onCancelSubscription()"
        (resumeSubscription)="onResumeSubscription()"
      />

      <div class="payment-history-container">
        <div class="payment-info-container">
          <div class="title">
            {{
              selectedSubscriptionData?.status === 'canceled'
                ? ('subscription.cancelationDate' | translate)
                : ('subscription.nextPayment' | translate)
            }}
            <!-- 
              This is hidden until we implement the correct logic for adding credit cards
            <button
              class="add-credit-card-link"
              (click)="onAddCreditCard()"
            >
              {{ 'subscription.addCreditCard' | translate }}
            </button> -->
          </div>
          <div
            class="month"
            *ngIf="selectedSubscriptionData?.status !== 'canceled'"
          >
            {{ formatDateWithTranslatedMonth(selectedSubscriptionData?.nextPaymentDate) }}
          </div>
          <div
            class="month"
            *ngIf="selectedSubscriptionData?.status === 'canceled'"
          >
            {{ formatDateWithTranslatedMonth(selectedSubscriptionData.canceledDate) }}
          </div>
          <div class="card">
            {{
              selectedSubscriptionData?.last4
                ? ('subscription.card' | translate) +
                  ': •••• •••• •••• ' +
                  selectedSubscriptionData?.last4
                : ''
            }}
            <button class="change-payment-method-button" (click)="onChangePaymentMethod()">{{ 'subscription.changePaymentMethod' | translate }}</button>
          </div>
        </div>
        <div class="billing-history-container">
          <div class="title">
            {{ 'subscription.billingHistory' | translate }}
          </div>

          <button
            *ngIf="!historyLoaded"
            (click)="getBillingHistoryItems()"
            [disabled]="historyLoaded"
            class="view-billing-details"
          >
            {{ 'subscription.viewBillingDetails' | translate }}
          </button>

          <div class="table-header" *ngIf="historyLoaded">
            <div class="table-date">{{ 'common.date' | translate }}</div>
            <div class="table-status">{{ 'common.status' | translate }}</div>
            <div class="table-invoice">
              {{ 'subscription.invoiceTotal' | translate }}
            </div>
          </div>

          <div class="table-body" *ngIf="historyLoaded">
            <div
              *ngFor="let billingHistoryItem of billingHistoryList"
              class="table-body-row"
            >
            <div class="table-date" *ngIf="billingHistoryItem?.status !== 'paid'">
              {{ billingHistoryItem.created | date : 'dd.MM.yyyy' }}
            </div>
              <div class="table-date" *ngIf="billingHistoryItem?.status === 'paid'">
                
                {{ billingHistoryItem.paid_at | date : 'dd.MM.yyyy' }}
              </div>
              <div class="table-status">{{ (billingHistoryItem?.status.charAt(0).toUpperCase() + billingHistoryItem?.status.slice(1))  | translate }}</div>
              <div class="table-invoice">
                {{ billingHistoryItem.currencyExchangeSymbol
                }}{{ billingHistoryItem.total | number : '.0-0' }}
              </div>
              <a
                class="table-download"
                [href]="billingHistoryItem.hosted_invoice_url"
                target="_blank"
              >
                <span *ngIf="billingHistoryItem?.status !== 'paid' && !selectedSubscriptionData?.cancellationRequested" 
                  class="pay-now-button"
                >
                  {{ 'subscription.payNow' | translate }}
                </span>  
                <svg
                *ngIf="billingHistoryItem?.status === 'paid' || (selectedSubscriptionData?.cancellationRequested && selectedSubscriptionData?.status !== 'paid')"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6C2 3.79086 3.79086 2 6 2Z"
                    stroke="#747EFA"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 13L12 16M12 16L15 13M12 16V8"
                    stroke="#747EFA"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="subscriptions-table">
        <table>
          <thead>
            <tr>
              <th>{{ 'subscription.subscription' | translate }}</th>
              <th>{{ 'subscription.organisationName' | translate }}</th>
              <th>{{ 'common.status' | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="subscription-table-row"
              [class.canceled]="subscriptionItem?.status === 'canceled'"
              [class.selected]="subscriptionItemId === subscriptionItem._id"
              (click)="onSubscriptionSelect(subscriptionItem)"
              *ngFor="let subscriptionItem of allSubscriptions"
            >
              <td>
                {{ subscriptionItem?.name | translate }}
              </td>
              <td *ngIf="subscriptionItem?.companyName">
                {{ subscriptionItem?.companyName }}
              </td>
              <td
                *ngIf="
                  !subscriptionItem?.companyName &&
                  subscriptionItem?.status !== 'canceled'
                "
              >
                <button
                  class="create-company-table"
                  (click)="onCreateNewCompany(subscriptionItem._id)"
                >
                  {{ 'subscription.createOrganisation' | translate }}
                </button>
              </td>
              <td
                *ngIf="
                  !subscriptionItem?.companyName &&
                  subscriptionItem?.status === 'canceled'
                "
              >
                {{ 'common.na' | translate }}
              </td>
              <td>
                {{ (subscriptionItem?.status.charAt(0).toUpperCase() + subscriptionItem?.status.slice(1)) | translate }}
              </td>
              <td>
                <span
                  *ngIf="subscriptionItem?.cancellationRequested && subscriptionItem?.status !== 'canceled'"
                  class="icon-info table-icon-info"
                  (mouseenter)="setIconInfoVisible(true, subscriptionItem?._id)"
                  (mouseleave)="
                    setIconInfoVisible(false, subscriptionItem?._id)
                  "
                >
                  <ops-info-tooltip
                    (onEnter)="setIconInfoVisible(true, subscriptionItem?._id)"
                    (onLeave)="setIconInfoVisible(false, subscriptionItem?._id)"
                    [tooltipVisible]="
                      iconInfoVisible &&
                      iconInfoVisibleId === subscriptionItem?._id
                    "
                    [tooltipBottom]="true"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        *ngIf="
                          iconInfoVisible &&
                          iconInfoVisibleId === subscriptionItem?._id
                        "
                        cx="10"
                        cy="10"
                        r="10"
                        fill="#FF3A4C"
                      />
                      <circle
                        *ngIf="
                          !iconInfoVisible ||
                          iconInfoVisibleId !== subscriptionItem?._id
                        "
                        cx="10"
                        cy="10"
                        r="10"
                        fill="#FF3A4C"
                        fill-opacity="0.22"
                      />
                      <path
                        d="M9.22159 14.5V7.40909H10.3111V14.5H9.22159ZM9.77557 6.22727C9.56321 6.22727 9.38009 6.15495 9.22621 6.0103C9.0754 5.86565 9 5.69176 9 5.48864C9 5.28551 9.38009 5.11162 9.22621 4.96697C9.38009 4.82232 9.56321 4.75 9.77557 4.75C9.98793 4.75 10.1695 4.82232 10.3203 4.96697C10.4742 5.11162 10.5511 5.28551 10.5511 5.48864C10.5511 5.69176 10.4742 5.86565 10.3203 6.0103C10.1695 6.15495 9.98793 6.22727 9.77557 6.22727Z"
                        fill="black"
                      />
                    </svg>
                    <span tooltip-content>
                      <b>{{
                        'subscription.cancelationRequested' | translate
                      }}</b
                      ><br />{{ 'subscription.cancelationMessage' | translate
                      }}<br />
                      <br />
                      <b>{{ 'subscription.cancelationDate' | translate }}:</b>
                      {{
                        subscriptionItem?.cancelAtPeriodEnd ?
                        formatDateWithTranslatedMonth(subscriptionItem?.cancelAtPeriodEnd) :
                        ''
                      }}
                    </span>
                  </ops-info-tooltip>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <button
          class="create-new-subscription"
          (click)="onCreateNewSubscription()"
        >
          + {{ 'subscription.startNewSubscription' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="subscription-container" *ngIf="stripeError">
  <div class="stripe-error" >
    <div class="stripe-error-message">
      {{ 'subscription.stripeErrorPleaseContactSupport' | translate }}
    </div>
  </div>
</div>

@if(showCreateNewOrganisation) {
<ops-create-company
  [subscriptionId]="subscriptionId"
  (closeModal)="onCloseCreateCompany()"
  (createdCompany)="onCreatedCompany($event)"
/>
}

@if(showPaymentMethodsModal) {
<ops-payment-methods-settings-modal
  [selectedSubscriptionData]="selectedSubscriptionData"
  (closeModal)="onClosePaymentMethodsModal()"
  (paymentMethodSelected)="onPaymentMethodSelected($event)"
  (updateDefaultPaymentMethodForSubscription)="updateDefaultPaymentMethodForSubscription()"
></ops-payment-methods-settings-modal>
}
